// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"e1b25316","239":"b3eff8db","732":"69ecbca8"}[chunkId] + ".chunk.js";
};